.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid transparent;
  border-radius: var(--cl-radius);
  background: transparent;
  color: var(--cl-text-secondary);
  cursor: pointer;
  transition: none;
}

.button:hover:not(:disabled) {
  color: var(--cl-text);
}

.button:focus-visible {
  outline: none;
  box-shadow: var(--cl-blue-focus-ring);
}

.button:disabled {
  opacity: 0.5;
  cursor: default;
}

.sm {
  width: 24px;
  height: 24px;
}

.md {
  width: 32px;
  height: 32px;
}

.lg {
  width: 40px;
  height: 40px;
}

.outlined {
  background: var(--cl-settings-back-bg);
  border-color: var(--cl-border-light);
  border-radius: var(--cl-radius-nd);
}

.round {
  border-radius: var(--cl-radius-round);
  background: var(--cl-bg-surface);
  box-shadow: var(--cl-sidebar-toggler-shadow);
}
